import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CreateProfileForm from './CreateProfileForm';

class EditGeneral extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.updateProfileField = this.updateProfileField.bind(this);
        this.state = {
            profile: this.props.profile
        };
     }

    componentDidMount() {  
       
    }

    componentWillUpdate(nextProps) {
        if(this.props.profile.ID !== nextProps.profile.ID) {
            this.setState({ profile: nextProps.profile });
        }
    }

    updateProfileField(event) {
        const name = event.target.name;
        const value = event.target.className === 'mdl-menu__item' ? event.target.innerText : event.target.value;
        const profile = {...this.state.profile};
        profile[name] = value;
        this.setState({ profile });
    }

    render() {
        return (
            <div id="divCreateForm">
                <CreateProfileForm currentProfile={this.state.profile} updateProfileField={this.updateProfileField} displayNarrow={false} />
            </div>
        );
    }
}

EditGeneral.propTypes = {
    profile: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default EditGeneral;